import './index.css'


const Education = () => {
  return (
    <div id="education">
    <h2 class="heading">Education</h2>
    

    <div class="education-block">
        <h3>University of California - Santa Barbara</h3>
        <span class="education-date">September 2022 - Present</span>
        <h4>B.S. Computer Engineering</h4>
        <ul>
            <li>
                Cumulative GPA: 3.97
            </li>
            <li>
                Dean's List Engineering
            </li>
        </ul>
    </div>
    
</div>
  );
};


export default Education